import type { StripeFocusElementType } from './focusInvalidStripeElement';

const PROGRAMMATIC_FOCUS_WINDOW_MS = 1000;

const programmaticFocusAtByType: Partial<Record<StripeFocusElementType, number>> = {};

/** Records that `elementType` was just focused programmatically, so a following focus event can be ignored. */
export function markProgrammaticFocus(elementType: StripeFocusElementType): void {
	programmaticFocusAtByType[elementType] = Date.now();
}

/**
 * Returns true when a focus event on `elementType` follows a programmatic focus of that same element,
 * so focus analytics can ignore it and only count user-initiated focus.
 */
export function consumeProgrammaticStripeFocus(elementType: StripeFocusElementType): boolean {
	const focusedAt = programmaticFocusAtByType[elementType];
	const isProgrammatic = focusedAt !== undefined && Date.now() - focusedAt < PROGRAMMATIC_FOCUS_WINDOW_MS;
	delete programmaticFocusAtByType[elementType];
	return isProgrammatic;
}
